import "../styles/brands.css";
import AutoScrollImages from "./AutoScrollimages";

function Brands() {

  return (
    <div className="brands-section">
      <h3 className="brands-title">Brands We Deal With</h3>

     <AutoScrollImages/>
    </div>
  );
}

export default Brands;